import get from 'lodash.get';
import site from '../../site';
import serviceClient from '../../service-client/service-client';
import errors from '../../errors';
import actions from '../actions';
import blocks from '../../blocks';
import constraints from '../../constraints';
import globals from '../../globals';
import siteDependencies from '../../site-dependencies';
import customization from '../../customization';
import siteLocales from '../../site-locales';
import blockTemplates from '../../block-templates';

const metaLoader = (store) => (next) => (action) => {
  if (action.type !== site.actionTypes.CONNECT_SITE) {
    next(action);
    return;
  }

  const client = serviceClient.get();
  const { site: siteData } = action.payload;

  // when user create site for the first time there is not `activePage` with id of active page in site meta,
  // however in this case we can take any page as they all have same `htmlLocale`
  const activePage =
    siteData.meta.pages.find((page) => page.id === siteData.meta.activePage) ||
    siteData.meta.pages[0];
  const activePageHtmlLocale = activePage && activePage.htmlLocale;
  const activePageLocale = activePage && activePage.locale;

  client
    .getTemplateMeta(siteData.templateBuildId)
    .then((response) => {
      const { meta: templateMeta, slug } = response.data;

      // globals should be loaded before all to avoid editor crushing
      store.dispatch(globals.actions.setGlobals(templateMeta.globals));
      store.dispatch(siteDependencies.actions.setDependencies(templateMeta.dependencies));

      store.dispatch(actions.setDesignAutomation(templateMeta.designAutomation));
      store.dispatch(actions.setPageTemplates(templateMeta.pageTemplates));
      store.dispatch(actions.setEmptyPage(templateMeta.emptyPage));
      store.dispatch(actions.setPageContainerSelector(templateMeta.pageContainer));
      store.dispatch(actions.loadMetaTranslations());
      store.dispatch(blocks.actions.setBlocks(templateMeta.blocks));
      store.dispatch(constraints.actions.setConstraints(templateMeta.constraints));
      store.dispatch(blocks.actions.setCategories(get(templateMeta, 'blockCategories', null)));
      store.dispatch(blockTemplates.actions.setBlockTemplates(templateMeta.blockTemplates));
      store.dispatch(
        customization.actions.setCustomizationConfiguration({
          ...templateMeta.customization,
          colorPalette: templateMeta.colorPalette,
          buttonPreset: templateMeta.buttonPreset,
        })
      );

      store.dispatch(actions.setVariables(templateMeta.variables));
      store.dispatch(actions.setSocialIcons(templateMeta.socialIcons));
      store.dispatch(
        actions.setSupportedBlockCategoriesForRegeneration(
          templateMeta.supportedBlockCategoriesForRegeneration
        )
      );
      store.dispatch(actions.setBuildSlug(slug));

      if (templateMeta.blocks) {
        store.dispatch(siteLocales.actions.clearBlocksHtml());

        const blockLoadingPromises = templateMeta.blocks.map(
          (block) =>
            new Promise((resolve, reject) => {
              store.dispatch(
                blocks.actions.initializeBlock(block.id, activePageLocale, activePageHtmlLocale, {
                  resolve,
                  reject,
                })
              );
            })
        );

        Promise.all(blockLoadingPromises).catch((error) => {
          errors.operations.catchError(error);
        });
      }

      next(action);
    })
    .catch((error) => {
      errors.operations.catchError(error);
    });
};

export default metaLoader;
